import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';

import { MasterTab } from '../../MasterTab';
import { deleteDataWithParameters, getAllDetailsDirect, postAllData } from '../../../../service/ProductService';
import { APPLICATIONS, UPDATE_APPLICATIONS } from '../../../../config/ApiConstant';
import { SkeletonbodyTemplate, Skeletonitems } from '../../../../appconfig/Settings';
import { ApplicationsListColumns } from '../../../../appconfig/DatatableSetting';
import { Dialog } from 'primereact/dialog';
import { AddUpdateApplicationValidate } from '../../../../config/Validate';

export const ApplicationMaster = () => {
    document.title = 'Application Master | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);


    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [applications, setApplications] = useState<any>([]);
    const [name, setName] = useState<any>('');
    const [addUpdateLoader, setAddUpdateLoader] = useState<boolean>(false);
    const [addUpdateModal, setAddUpdateModal] = useState<boolean>(false);
    const [editId, setEditId] = useState<any>(null);
    const [errors, setErrors] = useState<any>({});
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [deleteId, setDeleteId] = useState<any>(null);
    const [deleteLoader, setDeleteLoader] = useState<boolean>(false);

    // useEffect
    useEffect(() => {
        getApplicationsList();
    }, []);

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
                
            </>
        );
    };

    //rightToolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button label="Add Application" icon="pi pi-plus" className="p-button" onClick={() => openAddModal()} />
            </>
        );
    };

    // Get applications list
    const getApplicationsList = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetailsDirect(APPLICATIONS);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setApplications([]);
                } else {
                    setApplications(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(false);
                setApplications([]);
            }
        } catch (error: any) {
            setPageLoad(false);
            setApplications([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Open add modal
    const openAddModal = () => {
        setAddUpdateModal(true);
    };

    // Close add modal
    const closeAddUpdateModal = () => {
        setName('');
        setEditId(null);
        setAddUpdateLoader(false);
        setAddUpdateModal(false);
        setErrors({});
    };

    // Open edit modal
    const openEditModal = (rowData: any) => {
        setName(rowData.AppName);
        setEditId(rowData.SrNo);
        setAddUpdateModal(true);
    };

    // Open delete modal
    const openDeleteModal = (index: any) => {
        setDeleteId(index);
        setDeleteModal(true);
    };

    // Close delete modal
    const closeDeleteModal = () => {
        setDeleteId(null);
        setDeleteModal(false);
    };

    // Template for action
    const actionsTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <div className="flex">
                    <Button icon="pi pi-pencil" tooltip="Edit" tooltipOptions={{ position: 'top' }} className="p-button-rounded" onClick={() => openEditModal(rowData)} />
                    <Button icon="pi pi-trash" tooltip="Delete" tooltipOptions={{ position: 'top' }} className="p-button-danger p-button-rounded ml-2" onClick={() => openDeleteModal(rowData.SrNo)} />
                </div>
            </>
        );
    };

    // On submit add update app
    const onSubmitAddUpdateApp = async () => {
        try {
            const { errors, isError } = AddUpdateApplicationValidate(name);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setAddUpdateLoader(true);

                let formData: any = new FormData();
                let apiSlug = APPLICATIONS;
                if (editId !== null) {
                    apiSlug = UPDATE_APPLICATIONS;
                    formData.append('SrNo', editId);
                }
                formData.append('AppName', name);

                //apicall
                const response = await postAllData(apiSlug, formData);
                if (response && !window.cn(response)) {
                    setName('');
                    setEditId(null);
                    setAddUpdateLoader(false);
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                    setTimeout(() => {
                        setAddUpdateModal(false);
                        getApplicationsList();
                    }, 1000);
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast

                setAddUpdateLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Delete application
    const deleteApplication = async () => {
        try {
            setDeleteLoader(true);
            // Delete api call
            const response = await deleteDataWithParameters(APPLICATIONS + '?SrNo=' + deleteId);
            if (response) {
                setDeleteLoader(false);
                setDeleteModal(false);
                setDeleteId(null);
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response?.data
                });
                setTimeout(() => {
                    getApplicationsList();
                }, 1500);
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong, Please try again.'
                });
                setDeleteLoader(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setDeleteLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
           <MasterTab mainTabLabel="Application Master" />
            <Toast ref={toast} />
            <div className="grid crud-demo mt-3">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable value={applications} showGridlines stripedRows className="datatable-responsive p-datatable-sm"  globalFilter={globalFilter} emptyMessage="No Data Found">
                                    {ApplicationsListColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {ApplicationsListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Add Update Dialog */}
            <Dialog
                visible={addUpdateModal}
                className="p-fluid"
                style={{ width: '450px' }}
                header={editId !== null ? 'Edit Application' : 'Add Application'}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeAddUpdateModal} />
                        <Button label="Submit" icon="pi pi-check" className="p-button-primary" onClick={() => onSubmitAddUpdateApp()} loading={addUpdateLoader} />
                    </>
                }
                onHide={closeAddUpdateModal}
            >
                <div className="formgrid grid">
                    <div className="field col-12">
                        <label htmlFor="dname">
                            Application Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText value={name} name="dname" autoComplete="off" placeholder="Enter Application Name" onChange={(e) => setName(e.target.value)} className={errors['name'] && 'p-invalid'} />
                        <small className="p-invalid-txt">{errors['name']}</small>
                    </div>
                </div>
            </Dialog>

            {/* Delete Dialog */}
            <Dialog
                visible={deleteModal}
                style={{ width: '450px' }}
                header="Delete Application"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeDeleteModal} />
                        <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={deleteApplication} loading={deleteLoader} />
                    </>
                }
                onHide={closeDeleteModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <i className="pi pi-exclamation-triangle mr-3 delete-triangle" style={{ fontSize: '2rem' }} />
                    <span className="delete-dialog-note">Note: Once you delete this Application, This will be deleted permentatly.</span>
                </div>
            </Dialog>
        </>
    );
};
